import { render, staticRenderFns } from "./ThailandErpReport.vue?vue&type=template&id=57511138&scoped=true&"
import script from "./ThailandErpReport.vue?vue&type=script&lang=js&"
export * from "./ThailandErpReport.vue?vue&type=script&lang=js&"
import style0 from "./ThailandErpReport.vue?vue&type=style&index=0&id=57511138&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57511138",
  null
  
)

export default component.exports